import Component from '@glimmer/component';
import { format, isToday, isYesterday } from 'date-fns';
import removedString from 'garaje/helpers/removed-string';
import italicizeIfRemoved from 'garaje/modifiers/italicize-if-removed';

interface VisitorsHostedSummarySignature {
  Args: {
    /** Host name (e.g. entry.host / invite.host). */
    host?: string | null;
    /** Time to show: sign-in time for entries, expected arrival for invites. */
    time?: Date | null;
  };
  Element: HTMLParagraphElement;
}

export default class VisitorsHostedSummary extends Component<VisitorsHostedSummarySignature> {
  get formattedTime(): string {
    const { time } = this.args;
    if (!time) return '';
    const at = format(time, 'h:mm a');
    if (isToday(time)) return `Today, ${at}`;
    if (isYesterday(time)) return `Yesterday, ${at}`;
    return format(time, 'MMM d, h:mm a');
  }

  get showSeparator(): boolean {
    return Boolean(this.args.host && this.formattedTime);
  }

  <template>
    <p class="mb-0 text-sm font-normal text-carbon-50" ...attributes>
      {{#if @host}}Hosted by
        <strong data-private {{italicizeIfRemoved @host}} class="font-bold text-carbon-70">
          {{removedString @host}}
        </strong>
      {{/if}}
      {{#if this.showSeparator}}<span aria-hidden="true">·</span>{{/if}}
      {{this.formattedTime}}
    </p>
  </template>
}
